export type SquareData = {
  width?: number | string;
  src: string;
  style?: {};
};

const SquareImg: React.FC<SquareData> = (props) => {
  const baseStyle = {
    backgroundImage: "url(" + props?.src + ")",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: props.width ? props.width : "100%",
    aspectRatio: 1 / 1,
  };
  const style = {
    ...baseStyle,
    ...props.style,
  };
  return <div style={style} />;
};

export default SquareImg;
